import { render, staticRenderFns } from "./UserListDirectChat.vue?vue&type=template&id=724af3e0&scoped=true&"
import script from "./UserListDirectChat.vue?vue&type=script&lang=js&"
export * from "./UserListDirectChat.vue?vue&type=script&lang=js&"
import style0 from "./UserListDirectChat.vue?vue&type=style&index=0&id=724af3e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724af3e0",
  null
  
)

export default component.exports